/**
 * The Ads Builder's side panels: the layers panel beside the canvas (the screen's elements as a list to
 * pick, rename, fold and reorder — routes/playable-layers-panel.tsx), the fold of both it and the form
 * column (routes/playable-panel-edge.tsx), the line the form column shows when several elements are picked, and
 * the name of the download section, which only the rail's icon says (its sibling names live in
 * playable-templates-keys.ts, which is over the line cap).
 */
export const playableLayers: Record<string, string> = {
  'playable.layers.title': 'Layer',
  'playable.layers.collapse': 'Thu gọn panel Layer',
  'playable.layers.expand': 'Mở panel Layer',
  'playable.layers.empty': 'Màn này chưa có layer nào.',
  'playable.layers.emptyLocked': 'Màn này không có bản canvas để sửa, nên không có layer.',
  'playable.layers.drag': 'Kéo để đổi thứ tự (hoặc Alt+↑/↓)',
  'playable.layers.rename': 'Nháy đúp để đổi tên',
  'playable.layers.nameLabel': 'Tên layer — để trống thì dùng tên tự động',
  'playable.layers.duplicate': 'Nhân bản layer',
  'playable.layers.delete': 'Xóa layer',
  'playable.layers.eye': 'Ẩn layer',
  'playable.layers.lock': 'Khoá layer',
  'playable.layers.hide': 'Ẩn layer: không vẽ trên khung và không xuất vào quảng cáo',
  'playable.layers.show': 'Hiện lại layer',
  'playable.layers.hiddenByGroup': 'Đang ẩn vì nhóm chứa layer này bị ẩn',
  'playable.layers.hiddenFrozen': 'Đang ẩn. Lúc này không đổi được (màn chỉ xem, hoặc quảng cáo đang chạy thử)',
  'playable.layers.hideTrigger': 'Đây là chỗ chạm để chuyển màn (hoặc nhóm chứa nó): không ẩn được',
  'playable.layers.lockIt': 'Khoá layer: không chọn, kéo hay đổi cỡ được trên khung',
  'playable.layers.unlock': 'Mở khoá layer',
  'playable.layers.lockedByGroup': 'Đang khoá vì nhóm chứa layer này bị khoá',
  'playable.layers.lockedFrozen': 'Đang khoá. Lúc này không đổi được (màn chỉ xem, hoặc quảng cáo đang chạy thử)',
  'adsv2.build.sections.hiddenNote': 'Layer này đang ẩn: không có trong khung và không xuất. Bấm hình con mắt để hiện lại.',
  'adsv2.build.sections.lockedNote': 'Layer này đang khoá: không chọn, kéo hay đổi cỡ được trên khung (sửa ở thẻ này vẫn được).',
  'playable.form.title': 'Tùy chỉnh',
  'playable.form.collapse': 'Thu gọn cột tùy chỉnh',
  'playable.form.expand': 'Mở cột tùy chỉnh',
  'adsv2.build.sections.export': 'Tải xuống',
  'adsv2.build.sections.pickedMany': 'Đang chọn {n} phần tử. Chọn một phần tử để chỉnh.',
}
